(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
  class FAQSection {
    constructor(section) {
      this.section = section;
      this.items = Array.from(section.querySelectorAll('[data-faq-item]'));
      this.toggles = Array.from(section.querySelectorAll('[data-faq-toggle]'));
      
      this.init();
    }

    init() {
      this.setupEventListeners();
      this.openFirstItem();
      this.setupTransitionEnd();
    }

    closeAll(exceptEl) {
      this.items.forEach((item) => {
        if (item === exceptEl) return;
        const btn = item.querySelector('[data-faq-toggle]');
        const content = item.querySelector('[data-faq-content]');
        if (!content || !btn) return;
        if (item.classList.contains('is-open')) {
          btn.setAttribute('aria-expanded', 'false');
          this.animateClose(content);
          item.classList.remove('is-open');
        }
      });
    }

    animateOpen(content) {
      content.style.height = 'auto';
      const measured = content.scrollHeight;
      content.style.height = '0px';
      // reflow
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;
      content.style.height = measured + 'px';
    }

    animateClose(content) {
      const measured = content.scrollHeight;
      content.style.height = measured + 'px';
      // reflow
      // eslint-disable-next-line no-unused-expressions
      content.offsetHeight;
      content.style.height = '0px';
    }

    setupEventListeners() {
      this.toggles.forEach((btn) => {
        btn.addEventListener('click', () => {
          const item = btn.closest('[data-faq-item]');
          const content = item?.querySelector('[data-faq-content]');
          if (!item || !content) return;

          const isOpen = item.classList.contains('is-open');
          this.closeAll(isOpen ? null : item);

          if (isOpen) {
            btn.setAttribute('aria-expanded', 'false');
            this.animateClose(content);
            item.classList.remove('is-open');
          } else {
            btn.setAttribute('aria-expanded', 'true');
            item.classList.add('is-open');
            this.animateOpen(content);
          }
        });
      });
    }

    openFirstItem() {
      const first = this.items[0];
      if (first) {
        const firstBtn = first.querySelector('[data-faq-toggle]');
        const firstContent = first.querySelector('[data-faq-content]');
        if (firstBtn && firstContent) {
          first.classList.add('is-open');
          firstBtn.setAttribute('aria-expanded', 'true');
          // Set to intrinsic height without animation on load
          firstContent.style.height = 'auto';
          const measured = firstContent.scrollHeight;
          firstContent.style.height = measured + 'px';
        }
      }
    }

    setupTransitionEnd() {
      this.section.addEventListener('transitionend', (e) => {
        const content = e.target;
        if (!(content instanceof HTMLElement)) return;
        if (!content.matches('.faq__answer')) return;
        if (getComputedStyle(content).height !== '0px') {
          content.style.height = 'auto';
        }
      });
    }
  }

  // Initialize for each FAQ section
  document.addEventListener('DOMContentLoaded', () => {
    const faqSections = document.querySelectorAll('.faq-section');
    faqSections.forEach(section => {
      new FAQSection(section);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
  class HowItWorks {
    constructor(sectionId) {
      this.sectionId = sectionId;
      this.toggleBtn = document.getElementById(`${sectionId}-toggle`);
      this.items = document.querySelectorAll(`#${sectionId}-items .how-it-works__timeline-item`);
      this.isExpanded = false;

      this.init();
    }

    init() {
      if (this.toggleBtn) {
        this.toggleBtn.addEventListener('click', () => this.toggleAll());
      }
      
      // Calculate and set max-height for each description
      this.calculateHeights();
    }

    calculateHeights() {
      this.items.forEach(item => {
        const description = item.querySelector('.how-it-works__timeline-description');
        if (description) {
          // Temporarily set max-height to auto to get the natural height
          description.style.maxHeight = 'none';
          const naturalHeight = description.scrollHeight;
          
          // Reset to 0 for collapsed state
          description.style.maxHeight = '0px';
          
          // Set the CSS variable for the calculated height
          item.style.setProperty('--timeline-description-height', `${naturalHeight}px`);
        }
      });
    }

    toggleAll() {
      this.isExpanded = !this.isExpanded;
      
      this.items.forEach(item => {
        const description = item.querySelector('.how-it-works__timeline-description');
        if (description) {
          if (this.isExpanded) {
            item.classList.add('expanded');
            description.style.maxHeight = item.style.getPropertyValue('--timeline-description-height');
          } else {
            item.classList.remove('expanded');
            description.style.maxHeight = '0px';
          }
        }
      });

      // Update button state
      this.toggleBtn.setAttribute('aria-expanded', this.isExpanded.toString());
      const toggleText = this.toggleBtn.querySelector('.how-it-works__toggle-text');
      if (toggleText) {
        toggleText.textContent = this.isExpanded ? 'Read less' : 'Read more';
      }
    }
  }

  // Initialize for each section
  document.addEventListener('DOMContentLoaded', () => {
    const sections = document.querySelectorAll('.how-it-works');
    sections.forEach(section => {
      const sectionId = section.querySelector('.how-it-works__timeline-items')?.id?.replace('-items', '');
      if (sectionId) {
        new HowItWorks(sectionId);
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // Initialize Swiper sliders and tag filtering
  document.addEventListener('DOMContentLoaded', () => {
    const reviewSections = document.querySelectorAll('[data-reviews-swiper]');
    
    if (typeof Swiper === 'undefined') {
      // Swiper is not loaded!
      return;
    }
    
    reviewSections.forEach((section) => {
      try {
        const reviewsSection = section.closest('.reviews');

        // Calculate right offset to prevent overscroll
        // With symmetric padding, no offset is needed
        const getRightOffset = () => {
          return 0;
        };

        const swiper = new Swiper(section, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          autoHeight: true,
          resistanceRatio: 100,
          slidesOffsetAfter: getRightOffset(),
          navigation: {
            nextEl: reviewsSection.querySelector('[data-reviews-next]'),
            prevEl: reviewsSection.querySelector('[data-reviews-prev]'),
          },
        });

        // Update offset on resize
        window.addEventListener('resize', () => {
          swiper.params.slidesOffsetAfter = getRightOffset();
          swiper.update();
        });

        // Tag filtering functionality
        const tagsContainer = reviewsSection.querySelector('[data-reviews-tags]');
        if (tagsContainer) {
          const tagButtons = tagsContainer.querySelectorAll('.reviews__tag');
          const reviewCards = reviewsSection.querySelectorAll('.reviews__card');

          tagButtons.forEach(button => {
            button.addEventListener('click', () => {
              const selectedTag = button.getAttribute('data-tag');
              
              // Update active tag button
              tagButtons.forEach(btn => btn.classList.remove('reviews__tag--active'));
              button.classList.add('reviews__tag--active');
              
              // Get the swiper wrapper
              const swiperWrapper = swiper.wrapperEl;
              
              // Filter review cards by actually moving them in/out of the DOM
              reviewCards.forEach(card => {
                if (selectedTag === 'all') {
                  // Show all cards
                  if (!swiperWrapper.contains(card)) {
                    swiperWrapper.appendChild(card);
                  }
                  card.classList.remove('reviews__card--hidden');
                } else {
                  const cardTags = card.getAttribute('data-review-tags');
                  if (cardTags && cardTags.includes(`review-tag-${selectedTag}`)) {
                    // Show matching cards
                    if (!swiperWrapper.contains(card)) {
                      swiperWrapper.appendChild(card);
                    }
                    card.classList.remove('reviews__card--hidden');
                  } else {
                    // Hide non-matching cards by removing from DOM
                    if (swiperWrapper.contains(card)) {
                      swiperWrapper.removeChild(card);
                    }
                    card.classList.add('reviews__card--hidden');
                  }
                }
              });
              
              // Update Swiper after filtering
              setTimeout(() => {
                swiper.update();
                swiper.slideTo(0);
              }, 100);
            });
          });
        }
        
      } catch (error) {
        // Swiper initialization failed
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stories"] && !Shopify.designMode) return;
  try {
    
  // Initialize Swiper sliders
  document.addEventListener('DOMContentLoaded', () => {
    const storySections = document.querySelectorAll('[data-stories-swiper]');
    
    if (typeof Swiper === 'undefined') {
      return;
    }
    
    storySections.forEach((section) => {
      const paginationEl = section.closest('.stories').querySelector('.swiper-pagination');
      
      try {
        const root = section.closest('.stories');
        const swiper = new Swiper(section, {
          slidesPerView: 'auto',
          spaceBetween: 12,
          autoHeight: true,
          pagination: {
            el: paginationEl,
            clickable: true,
          },
          navigation: {
            nextEl: root.querySelector('[data-stories-next]'),
            prevEl: root.querySelector('[data-stories-prev]'),
          },
        });
      } catch (error) {
        // Swiper initialization failed
      }
    });
  });

  // Modal functionality
  document.addEventListener('DOMContentLoaded', () => {
    const modalTriggers = document.querySelectorAll('[data-story-modal-trigger]');
    const modals = document.querySelectorAll('[data-story-modal]');
    const modalCloses = document.querySelectorAll('[data-story-modal-close]');

    // Open modal
    modalTriggers.forEach(trigger => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        const modalId = trigger.getAttribute('data-story-modal-trigger');
        const modal = document.querySelector(`[data-story-modal="${modalId}"]`);
        
        if (modal) {
          modal.classList.add('is-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    // Close modal
    const closeModal = (modal) => {
      modal.classList.remove('is-active');
      document.body.style.overflow = '';
    };

    modalCloses.forEach(close => {
      close.addEventListener('click', () => {
        const modal = close.closest('.stories__modal');
        if (modal) {
          closeModal(modal);
        }
      });
    });

    // Close modal on overlay click
    modals.forEach(modal => {
      const overlay = modal.querySelector('.stories__modal-overlay');
      if (overlay) {
        overlay.addEventListener('click', () => {
          closeModal(modal);
        });
      }
    });

    // Close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        const activeModal = document.querySelector('.stories__modal.is-active');
        if (activeModal) {
          closeModal(activeModal);
        }
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
